// src/api/users.ts
import api from './api';

export interface User {
  id: string;
  user_id: string;
  email: string;
  first_name: string;
  last_name: string;
  name: string;
  role: string;
  is_active: boolean;
  headOfficeID?: string;
  branchID?: string;
}

export interface DirectMailPayload {
  employee_id?: string;
  user_id?: string;
  email?: string;
  subject: string;
  message: string;
}

export interface DirectMailResponse {
  success: boolean;
  message: string;
  data?: any;
}

export interface UsersResponse {
  success: boolean;
  users: User[];
  total: number;
}

// Get all users from backend
export const getAllUsers = async (): Promise<UsersResponse> => {
  try {
    console.log('API: Fetching all users from /users/all');
    const response = await api.get('/users/all');
    console.log('API: Successfully fetched users:', response.data.users?.length);
    return response.data;
  } catch (error: any) {
    console.error('API: Error fetching users:', error);
    throw new Error(error?.response?.data?.detail || error.message);
  }
};

export const sendDirectMail = async (payload: DirectMailPayload): Promise<DirectMailResponse> => {
  try {
    console.log('API: Sending direct mail to:', payload.email || payload.user_id || payload.employee_id);
    const response = await api.post('/users/direct-mail', payload);
    console.log('API: Direct mail sent successfully');
    return response.data;
  } catch (error: any) {
    console.error('API: Error sending direct mail:', error);
    throw new Error(error?.response?.data?.detail || error.message);
  }
};